// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalFormWrapper_wrapper__nchor","heading":"ModalFormWrapper_heading__XOsBq","title":"ModalFormWrapper_title__yi4wW","closeButton":"ModalFormWrapper_closeButton__Wz3GG"};